<template>
  <div class="filter-list">
    <v-list dense class="backgroundWhite">
      <v-list-item
        v-for="(filter, index) in list_filters"
        :key="`filter_${index}`"
        @click="filter_list(`${filter.value}`)"
        :inactive="loading"
        v-ripple="false"
        :class="{
          active: primary_filter_conditions ? primary_filter_conditions == filter.value : current_tab == filter.value,
        }"
      >
        <v-list-item-title class="bold">
          {{ filter.label }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
export default {
  name: "PrimaryFiltersVT",
  props: { list_filters: Array, current_tab: String, loading: Boolean },
  watch: {
    current_tab(newVal) {
      this.filter_list(newVal);
    },
  },
  data: function () {
    return {
      primary_filter_conditions: "",
    };
  },
  methods: {
    filter_list(filter_string) {
      if (!this.loading) {
        this.primary_filter_conditions = filter_string;
        this.$emit("filter_update", filter_string);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.filter-list {
  ::v-deep .v-list--dense {
    display: flex;
    .v-list-item {
      color: var(--v-backgroundWhite-base);
      flex: none;
      .v-list-item__title {
        color: var(--v-primaryGrey-base);
        cursor: pointer;
      }
      .v-list-item__title:hover {
        color: var(--v-borderDark-base);
      }
    }
    .v-list-item:first-of-type {
      padding-left: 0;
    }
    .v-list-item.active {
      .v-list-item__title {
        color: var(--v-borderDark-base);
        cursor: pointer;
      }
    }
    .v-list-item:focus {
      .v-list-item__title {
        text-decoration: underline;
      }
    }
  }
}
</style>
